import apiClient from './client';

interface GameConfig {
  baseScore: number;
  maxPointsPerRound: number;
  numberOfRounds: number;
}

export const settingsApi = {
  async getGameConfig(): Promise<GameConfig> {
    const response = await apiClient.get('/settings/game/config');
    return response.data.data;
  },
};
